import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import * as Sentry from '@sentry/react'
import './index.css'
import App from './App.jsx'

// Initialize Sentry — only runs when DSN is set (skipped in local dev if .env is empty)
if (import.meta.env.VITE_SENTRY_DSN) {
  Sentry.init({
    dsn:              import.meta.env.VITE_SENTRY_DSN,
    environment:      import.meta.env.MODE,           // "production" | "development"
    release:          import.meta.env.VITE_APP_VERSION || "neo-detail@0.0.0",
    integrations:     [Sentry.browserTracingIntegration()],
    tracesSampleRate: 0.2,   // 20% of transactions — keeps quota low
    // Don't send errors from localhost
    beforeSend(event) {
      if (window.location.hostname === "localhost") return null;
      return event;
    },
  });
}

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
